export type AdministrationRoute =
  | 'medication_variable'
  | 'medication_im'
  | 'medication_sc'
  | 'medication_iv'
  | 'kit_im'
  | 'kit_sc'
  | 'kit_iv_soro'
  | 'kit_iv_seringa'
  | 'other';

export const ADMINISTRATION_ROUTE_OPTIONS: { value: AdministrationRoute | ''; label: string }[] = [
  { value: '', label: 'Não classificado' },
  { value: 'medication_variable', label: 'Medicação (variável)' },
  { value: 'medication_im', label: 'Medicação IM' },
  { value: 'medication_sc', label: 'Medicação SC' },
  { value: 'medication_iv', label: 'Medicação EV' },
  { value: 'kit_im', label: 'Kit intramuscular' },
  { value: 'kit_sc', label: 'Kit subcutâneo' },
  { value: 'kit_iv_soro', label: 'Kit / soro EV' },
  { value: 'kit_iv_seringa', label: 'Kit seringa EV' },
  { value: 'other', label: 'Outro' },
];

export const EVOLUTION_QUICK_ADD_ROUTES: { route: AdministrationRoute; label: string }[] = [
  { route: 'kit_iv_soro', label: '+ Soro EV' },
  { route: 'kit_iv_seringa', label: '+ Seringa EV' },
  { route: 'kit_im', label: '+ Kit IM' },
  { route: 'kit_sc', label: '+ Kit SC' },
];

export type ProcedureConsumptionMode = 'auto_per_execution' | 'manual_only';

export const PROCEDURE_CONSUMPTION_MODE_OPTIONS: { value: ProcedureConsumptionMode; label: string; hint: string }[] = [
  {
    value: 'auto_per_execution',
    label: 'Automático (cada execução)',
    hint: 'Kit SC/IM ou insumo fixo por procedimento — entra na sugestão da evolução.',
  },
  {
    value: 'manual_only',
    label: 'Só manual na evolução',
    hint: 'Medicações variáveis ou soro EV compartilhado — a equipe lança na hora.',
  },
];

export type ProcedureQuantityUnit = 'item_unit' | 'mg';

export const PROCEDURE_QUANTITY_UNIT_OPTIONS: { value: ProcedureQuantityUnit; label: string; hint?: string }[] = [
  { value: 'item_unit', label: 'Unidade do item', hint: 'Kit, ampola inteira, par, etc.' },
  { value: 'mg', label: 'Miligramas (frasco fracionado)', hint: 'Ex.: Tirzepatida — informe mg aplicados; o sistema calcula a fração do frasco.' },
];

export function vialTotalMgFromItemMetadata(metadata: unknown): number | null {
  const m = metadata as Record<string, unknown> | null;
  const direct = Number(m?.vial_total_mg);
  if (Number.isFinite(direct) && direct > 0) return direct;
  const cq = m?.content_quantity;
  if (cq == null) return null;
  const s = String(cq).trim().toLowerCase().replace(/\s/g, '');
  const match = s.match(/^(\d+(?:[.,]\d+)?)\s*mg$/);
  if (match) {
    const n = Number(match[1].replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : null;
  }
  return null;
}

/** Mesma regra do backend (Tirzepatida / fracionado). */
export function resolveMaterialQuantity(params: {
  quantity_per_execution: number;
  quantity_unit?: ProcedureQuantityUnit | string | null;
  itemMetadata?: unknown;
}): number {
  const qty = Number(params.quantity_per_execution);
  if (!Number.isFinite(qty) || qty <= 0) return 1;
  const unit = (params.quantity_unit || 'item_unit') as ProcedureQuantityUnit;
  if (unit !== 'mg') return qty;
  const vialMg = vialTotalMgFromItemMetadata(params.itemMetadata);
  if (!vialMg) return qty;
  const fracs = qty / vialMg;
  return Math.min(1, Math.max(0.001, Math.round(fracs * 1000) / 1000));
}
